<template>
    <status-badge :label="label" :icon="icon" :color-class="colorClass" />
</template>

<script>
  import StatusBadge from './StatusBadge'
  export default {
    name: 'ProjectStatusBadge',
    components: {StatusBadge},
    props: {
      status: Number
    },
    computed: {
      label() {
        switch (this.status) {
          case 0: return 'ProjectDetails.statusNotOrdered';
          case 1: return 'ProjectDetails.statusOrdered';
          case 2: return 'ProjectDetails.statusExpired';
          case 3: return 'ProjectDetails.statusReview';
          case 4: return 'ProjectDetails.statusApproved';
          case 5: return 'ProjectDetails.statusRejected';
          default: return 'Unknown: ' + this.status;
        }
      },
      icon() {
        switch (this.status) {
          case 0: return 'fa fa-clock';
          case 1: return 'fa fa-check';
          case 2: return 'fa fa-check';
          case 3: return 'fas fa-search';
          case 4: return 'fas fa-thumbs-up';
          case 5: return 'fas fa-thumbs-down';
          default: return 'fa fa-unknown';
        }
      },
      colorClass() {
        switch (this.status) {
          case 0: return 'warning';
          case 1: return 'success';
          case 2: return 'warning';
          case 3: return 'info';
          case 4: return 'success';
          case 5: return 'dang er';
          default: return 'unknown';
        }
      }
    }
  }
</script>

<style scoped>

</style>
